module.exports = __webpack_public_path__ + "img/shark-background-align-top.6778aea8.png";